export const buMainPath = "/bu";
export const corpMainPath = "/corp";
export const comMainPath = `/com`;
export const corpSlugParam = "corporationSlug";
export const buSlugParam = "buSlug";
export const comSlugParam = "communitySlug";
export const kenMainPath = "/kensaku-kun";

export const personalRoutePath = {
  root: {
    root: "/",
    staff: { root: "/staff" },
  },
};
export const personalSlugParam = "personalSlug";
export const employeeMainPath = "/employee";
export const staffMainPath = "/staff";
export const clientMainPath = "/client";

export const businessEstablishmentSlugParam = "businessEstablishmentSlug";
export const organizationSlugParam = "organizationSlug";
export const jobListingSlugParam = "jobListingSlug";

export const buRoutePaths = {
  root: {
    root: buMainPath,
    pBuSlug: {
      root: `${buMainPath}/:${buSlugParam}`,
      generalSetting: {
        root: `${buMainPath}/:${buSlugParam}/general-setting`,
        otherSetting: {
          root: `${buMainPath}/:${buSlugParam}/general-setting/other-setting`,
        },
      },
      member: {
        root: `${buMainPath}/:${buSlugParam}/member`,
        corp: {
          root: `${buMainPath}/:${buSlugParam}/member/corp`,
          pCorporationSlug: {
            root: `${buMainPath}/:${buSlugParam}/member/corp/:${corpSlugParam}`,
          },
        },
        pPersonal: {
          root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}`,
          desiredJobPreferences: {
            root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}/desired-job-preferences`,
          },
          workHistoryAndOther: {
            root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}/work-history-others`,
          },
          laborManagement: {
            root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}/labor-management`,
          },
          currentStatus: {
            root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}/current-status`,
          },
          pastStatus: {
            root: `${buMainPath}/:${buSlugParam}/member/:${personalSlugParam}/past-status`,
          },
        },
        employee: {
          root: `${buMainPath}/:${buSlugParam}/member/employee`,
        },
        staff: {
          root: `${buMainPath}/:${buSlugParam}/member/staff`,
        },
        client: {
          root: `${buMainPath}/:${buSlugParam}/member/client`,
        },
        corporation: {
          root: `${buMainPath}/:${buSlugParam}/member/corporation`,
        },
      },
      managePostings: {
        root: `${buMainPath}/:${buSlugParam}/manage-postings`,
        activeVacancies: {
          root: `${buMainPath}/:${buSlugParam}/manage-postings/active-vacancies`,
          exportSummary: {
            root: `${buMainPath}/:${buSlugParam}/manage-postings/active-vacancies/export-summary`,
          },
          exportWebAds: {
            root: `${buMainPath}/:${buSlugParam}/manage-postings/active-vacancies/export-web-ads`,
          },
        },
        unpublished: {
          root: `${buMainPath}/:${buSlugParam}/manage-postings/unpublished`,
        },
      },
      assignedAccount: {
        root: `${buMainPath}/:${buSlugParam}/assigned-account`,
        staff: {
          root: `${buMainPath}/:${buSlugParam}/assigned-account/staff`,
        },
        client: {
          root: `${buMainPath}/:${buSlugParam}/assigned-account/client`,
        },
        corporation: {
          root: `${buMainPath}/:${buSlugParam}/assigned-account/corproation`,
        },
        manage: {
          root: `${buMainPath}/:${buSlugParam}/assigned-account/manage`,
          manageMemberAssignment: {
            root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/assignment`,
            memberAssignment: {
              root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/assignment/:${personalSlugParam}`,
              staff: {
                root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/assignment/:${personalSlugParam}/staff`,
              },
              client: {
                root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/assignment/:${personalSlugParam}/client`,
              },
              corporation: {
                root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/assignment/:${personalSlugParam}/corproation`,
              },
            },
          },
          unassignedAccount: {
            root: `${buMainPath}/:${buSlugParam}/assigned-account/manage/unassigned`,
          },
        },
      },
      manageTags: {
        root: `${buMainPath}/:${buSlugParam}/manage-tags`,
      },
      pastNotes: {
        root: `${buMainPath}/:${buSlugParam}/past-notes`,
        insideSales: {
          root: `${buMainPath}/:${buSlugParam}/past-notes/inside-sales`,
        },
        fieldSales: {
          root: `${buMainPath}/:${buSlugParam}/past-notes/field-sales`,
        },
        customerSuccess: {
          root: `${buMainPath}/:${buSlugParam}/past-notes/customer-success`,
        },
      },
      scorecardHistory: {
        root: `${buMainPath}/:${buSlugParam}/scorecard-history`,
        scorecardHistoryStaff: {
          root: `${buMainPath}/:${buSlugParam}/scorecard-history/staff`,
        },
        scorecardHistoryJobListingCorporation: {
          root: `${buMainPath}/:${buSlugParam}/scorecard-history/job-listing-corporation`,
        },
      },
    },
  },
};

export const corpRoutePaths = {
  root: {
    root: corpMainPath,
    pCorpSlug: {
      root: `${corpMainPath}/:${corpSlugParam}`,
      generalSetting: {
        root: `${corpMainPath}/:${corpSlugParam}/general-setting`,
      },
      member: {
        root: `${corpMainPath}/:${corpSlugParam}/member`,
        pPersonal: {
          root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}`,
          desiredJobPreferences: {
            root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}/desired-job-preferences`,
          },
          workHistoryAndOther: {
            root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}/work-history-others`,
          },
          laborManagement: {
            root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}/labor-management`,
          },
          currentStatus: {
            root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}/current-status`,
          },
          pastStatus: {
            root: `${corpMainPath}/:${corpSlugParam}/member/:${personalSlugParam}/past-status`,
          },
        },
        employee: {
          root: `${corpMainPath}/:${corpSlugParam}/member/employee`,
        },
        staff: {
          root: `${corpMainPath}/:${corpSlugParam}/member/staff`,
        },
        client: {
          root: `${corpMainPath}/:${corpSlugParam}/member/client`,
        },
        corporation: {
          root: `${corpMainPath}/:${corpSlugParam}/member/corporation`,
        },
      },
      businessEstablishment: {
        root: `${corpMainPath}/:${corpSlugParam}/business-establishment`,
        detail: {
          root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}`,
          organization: {
            root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}/organization`,
            detail: {
              root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}/organization/:${organizationSlugParam}`,
              jobListing: {
                root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}/organization/:${organizationSlugParam}/job-listing`,
                detail: {
                  root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}/organization/:${organizationSlugParam}/job-listing/:${jobListingSlugParam}`,
                  brochure: {
                    root: `${corpMainPath}/:${corpSlugParam}/business-establishment/:${businessEstablishmentSlugParam}/organization/:${organizationSlugParam}/job-listing/:${jobListingSlugParam}/brochure`,
                  },
                },
              },
            },
          },
        },
        organizations: {
          root: `${corpMainPath}/:${corpSlugParam}/business-establishment/organization`,
        },
        joblisting: {
          root: `${corpMainPath}/:${corpSlugParam}/business-establishment/job-listing`,
        },
      },
      activeVacancies: {
        root: `${corpMainPath}/:${corpSlugParam}/active-vacancies`,
        export: {
          root: `${corpMainPath}/:${corpSlugParam}/active-vacancies/export-web-ads`,
        },
      },
      pastNotes: {
        root: `${corpMainPath}/:${corpSlugParam}/past-notes`,
      },
    },
  },
};

export const comRoutePaths = {
  root: {
    root: comMainPath,
  },
};

export const employeeRoutePaths = {
  root: {
    root: employeeMainPath,
    pEmployeeSlug: {
      root: `${employeeMainPath}/:${personalSlugParam}`,
      generalSetting: {
        root: `${employeeMainPath}/:${personalSlugParam}/general-setting`,
        laborManagement: {
          root: `${employeeMainPath}/:${personalSlugParam}/general-setting/labor-management`,
        },
        otherSetting: {
          root: `${employeeMainPath}/:${personalSlugParam}/general-setting/other-setting`,
        },
      },
      member: {
        root: `${employeeMainPath}/:${personalSlugParam}/member`,
        corp: {
          root: `${employeeMainPath}/:${personalSlugParam}/member/corporation`,
        },
        bu: {
          root: `${employeeMainPath}/:${personalSlugParam}/member/business-unit`,
        },
      },
    },
  },
};

export const staffRoutePaths = {
  root: {
    root: staffMainPath,
    pStaffSlug: {
      root: `${staffMainPath}/:${personalSlugParam}`,
      generalSetting: {
        root: `${staffMainPath}/:${personalSlugParam}/general-setting`,
        desiredJobPreferences: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/desired-job-preferences`,
        },
        workHistoryAndOther: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/work-history-others`,
        },
        laborManagement: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/labor-management`,
        },
        currentStatus: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/current-status`,
        },
        pastStatus: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/past-status`,
        },
        otherSetting: {
          root: `${staffMainPath}/:${personalSlugParam}/general-setting/other-setting`,
        },
      },
      member: {
        root: `${staffMainPath}/:${personalSlugParam}/member`,
        bu: {
          root: `${staffMainPath}/:${personalSlugParam}/member/business-unit`,
        },
      },
      employedCorporation: {
        root: `${staffMainPath}/:${personalSlugParam}/employed-corporation`,
      },
      pastNotes: {
        root: `${staffMainPath}/:${personalSlugParam}/past-notes`,
        insideSales: {
          root: `${staffMainPath}/:${personalSlugParam}/past-notes/inside-sales`,
        },
        customerSuccess: {
          root: `${staffMainPath}/:${personalSlugParam}/past-notes/customer-success`,
        },
      },
    },
  },
};

export const clientRoutePaths = {
  root: {
    root: clientMainPath,
    pClientSlug: {
      root: `${clientMainPath}/:${personalSlugParam}`,
      generalSetting: {
        root: `${clientMainPath}/:${personalSlugParam}/general-setting`,
        otherSetting: {
          root: `${clientMainPath}/:${personalSlugParam}/general-setting/other-setting`,
        },
      },
      member: {
        root: `${clientMainPath}/:${personalSlugParam}/member`,
        corp: {
          root: `${clientMainPath}/:${personalSlugParam}/member/corporation`,
        },
        bu: {
          root: `${clientMainPath}/:${personalSlugParam}/member/business-unit`,
        },
      },
      corporationDetail: {
        root: `${clientMainPath}/:${personalSlugParam}/corporation-detail`,
      },
      employedStaff: {
        root: `${clientMainPath}/:${personalSlugParam}/employed-staff`,
      },
    },
  },
};

export const kensakuKunRoutePaths = {
  root: kenMainPath,
  staff: {
    root: `${kenMainPath}/search-staff`,
  },
  employee: {
    root: `${kenMainPath}/search-employee`,
  },
  client: {
    root: `${kenMainPath}/search-client`,
  },
  corporation: {
    root: `${kenMainPath}/search-corporation`,
  },
  jobListing: {
    root: `${kenMainPath}/search-job-listing`,
  },
};

export const routePaths = {
  root: {
    root: "/",
    search: {
      root: "/search",
      personal: {
        root: "/search/personal",
      },
      bu: {
        root: "/search/bu",
      },
      corporation: {
        root: "/search/corporation",
      },
    },
    generalSetting: {
      root: "/general-setting",
      laborManagement: {
        root: "/general-setting/labor-management",
      },
      otherSetting: {
        root: "/general-setting/other-setting",
      },
    },
    myRole: {
      root: "/my-role",
    },
    member: {
      root: "/member",
      corp: {
        root: "/member/corporation",
      },
      bu: {
        root: "/member/business-unit",
      },
    },
    employee: employeeRoutePaths,
    staff: staffRoutePaths,
    client: clientRoutePaths,
    bu: buRoutePaths,
    corp: corpRoutePaths,
    com: comRoutePaths,
    ken: kensakuKunRoutePaths,
  },
};
